import { popupTriggerManager } from "./popupTriggers";
import { POPUP_CONFIGS } from "../config/popupConfig";
import { useHomeDisplayStore } from "../modules/homeDisplay/stores";
import utils from "./utils";

/**
 * 下载APP激励活动是否处于「应展示营销弹窗」状态：
 * 活动生效 + 用户未达成/未领取 + 浏览器环境（APP/PWA 内走领取弹窗，不再营销下载）。
 */
export const isAppDownloadActivityPromoActive = (): boolean => {
  if (utils.isApp() || utils.updateCheckIsPwa()) return false;
  const promo = useHomeDisplayStore.getState().data?.appDownloadPromo;
  if (!promo?.activity) return false;
  return promo.userAchievedOrClaimed !== true;
};

/**
 * 触发应用下载弹窗（所有手动入口统一走这里：Profile 的 APP 按钮、顶部下载条、活动浮标等）。
 *
 * 路由规则：
 * - 下载激励活动生效且用户未领取 → 居中活动营销弹窗（DOWNLOAD_APP 槽位，手动触发不受节奏限制）；
 * - 其他情况 → 旧 AppDownloadDialog。
 *
 * 注意：AppDownloadDialog 只能在首页 (/)、Profile (/profile)、Event Center (/event-center) 触发。
 */
export const triggerAppDownloadDialog = (): boolean => {
  if (isAppDownloadActivityPromoActive()) {
    return popupTriggerManager.trigger(POPUP_CONFIGS.DOWNLOAD_APP.id);
  }
  return popupTriggerManager.trigger(POPUP_CONFIGS.APP_DOWNLOAD_DIALOG.id);
};
